/*
AddClasses - Handles teachers who don't have classes already in the database and prompts them to add classes. 
            The class information is read from the database.

plertErro - displays a error message to the user if they try to submit an empty array of no classes
checkUnCheck - controls if a the users has checked or unchecked a value to add in an array
classesToForm - gets a snapshot of the classes offered in the database
createClassFormElement - creates an form based on the information received from the database
*/
import React, { useState, useEffect } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { auth, db } from '../firebase/config';
import { doc, getDoc } from 'firebase/firestore';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

function AddClasses() {
    const [className, setClassName] = useState('');
    const [abbreviatedName, setAbbreviatedName] = useState('');
    const [subject, setSubject] = useState('');
    const [instructorName, setInstructorName] = useState('');
    const [instructorEmail, setInstructorEmail] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        const user = auth.currentUser;
        if (user) {
            const userDocRef = doc(db, "users", user.uid);
            getDoc(userDocRef).then(docSnapshot => {
                if (docSnapshot.exists()) {
                    const data = docSnapshot.data();
                    setInstructorName(`${data.firstName} ${data.lastName}`);
                    setInstructorEmail(user.email);
                }
            }).catch(error => {
                console.error("Error fetching user data: ", error);
            });
        }
    }, [db]);

    const handleCreateClass = async (e) => {
        e.preventDefault();
        try {
            await addDoc(collection(db, "classes"), {
                name: className,
                abbreviatedName: abbreviatedName,
                subject: subject,
                instructorName: instructorName,
                email: instructorEmail
            });
            setSuccessMessage("Class created successfully!");
            setClassName('');
            setAbbreviatedName('');
            setSubject('');
        } catch (error) {
            console.error("Error creating class: ", error);
        }
    };

    return (
        <Container className="bg-white p-4 shadow-sm rounded">
           <Row className="justify-content-center">
           <Col md={6}>
            <h2 className="custom-font">Create a New Class</h2>
            {successMessage && <Alert variant="success">{successMessage}</Alert>}
            <Form onSubmit={handleCreateClass}>
                <Form.Group controlId="className">
                    <Form.Label>Class Name</Form.Label>
                    <Form.Control 
                        type="text" 
                        placeholder="Enter class name" 
                        value={className}
                        onChange={(e) => setClassName(e.target.value)}
                        required
                    />
                </Form.Group>
                <Form.Group controlId="abbreviatedName" className="mt-3">
                    <Form.Label>Course Number</Form.Label>
                    <Form.Control 
                        type="text" 
                        placeholder="Enter abbreviated name" 
                        value={abbreviatedName}
                        onChange={(e) => setAbbreviatedName(e.target.value)}
                        required
                    />
                </Form.Group>
                <Form.Group controlId="subject" className="mt-3">
                    <Form.Label>Subject</Form.Label>
                    <Form.Control 
                        type="text" 
                        placeholder="Enter subject" 
                        value={subject}
                        onChange={(e) => setSubject(e.target.value)}
                        required
                    />
                </Form.Group>
                <Form.Group controlId="instructorName" className="mt-3">
                    <Form.Label>Instructor Name</Form.Label>
                    <Form.Control 
                        type="text" 
                        value={instructorName}
                        disabled
                    />
                </Form.Group>
                <Form.Group controlId="instructorEmail" className="mt-3">
                    <Form.Label>Instructor Email</Form.Label>
                    <Form.Control 
                        type="email" 
                        value={instructorEmail}
                        disabled
                    />
                </Form.Group>
                <Button variant="success" type="submit" className="mt-4">
                    Create Class
                </Button>
            </Form>
            <p>
          Back to Dashboard? {" "}
          <span>
            <Link to="/faculty/dashboard">Faculty Dashboard</Link>
          </span>
        </p>
        </Col>
        </Row>
        </Container>
    );
}

export default AddClasses;